import { createSlice } from "@reduxjs/toolkit";

type ContextState = {
  globalTimer: number;
};

const initialState: ContextState = {
  globalTimer: new Date().getTime(),
};

const contextSlice = createSlice({
  name: "timer",
  initialState,
  reducers: {
    timerTick: (state) => {
      state.globalTimer = new Date().getTime();
    },
  },
});

export const {
  // App Events

  timerTick,
} = contextSlice.actions;
export default contextSlice.reducer;
